<template>
    <v-app id="inspire">
        <v-content>
            <v-container
                    fluid
                    fill-height
            >
                <v-layout
                        align-center
                        justify-center
                >
                    <v-flex
                            xs12
                            sm8
                            md4
                    >
                        <v-card class="elevation-12">
                            <v-toolbar
                                    color="primary"
                                    dark
                                    flat
                            >
                                <v-toolbar-title>Destech Panel</v-toolbar-title>

                            </v-toolbar>
                            <v-card-text>
                                <v-form>
                                    <v-text-field
                                            label="Kullanıcı Adı"
                                            name="username"
                                            type="text"
                                            v-model="model.userName"
                                    ></v-text-field>

                                    <v-text-field
                                            id="password"
                                            label="Şifre"
                                            v-model="model.password"
                                            name="password"
                                            type="password"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="login">Giriş Yap</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    export default {
        name:"Login",
        components:{},
        data: () => ({
            model:{
                userName:"",
                password:""
            },
            imzaAlert:{
                type:"error",
                icon:"error",
                message:""
            }
        }),
        props: {
            source: String
        },
        beforeMount(){
            //this.heartBeatControl();
        },

        methods:{
            login(){
                this.$axios.post("login",this.model).then(response=>{
                    console.log("response",response);
                    this.$store.commit("setSession",response.data.token);
                    this.$store.dispatch("init");
                }).catch(err=>{
                    alert(err.message);
                });
                console.log(this.model);

            },
            /*
            eImzaGiris(e){
                e.preventDefault();
                //.goAway(1500)
                let toast = this.$toasted.show("E-imza ile giriş yapılıyor.");
                service.login().eimza().then((jsession64)=>{
                    toast.text("Imzalama başarılı arabulucu portala giriş yapılıyor ...");
                    console.log("jssession64",jsession64);
                    this.uyapSessionUrl  = "";
                    //https://arabulucu.uyap.gov.tr/main/jsp/arabulucu/index.jsp?menuId=13313
                    //Application.initializeForEnvironmentAfterLogin (
                    let jsessionId = base64.decode(jsession64);
                    this.$store.commit("setSession",jsessionId);
                    console.log(this.arabulucuUyapUrl+jsession64);
                    this.uyapSessionUrl = this.arabulucuUyapUrl+jsession64;
                    let uyapFrame = document.querySelector("#uyapFrame");
                    uyapFrame.onload = ()=> {
                        toast.text("Giriş başarılı oturum açılıyor ....").goAway(2500);
                        //this.$store.commit("setSession",jsessionId);
                        this.$store.dispatch("login");
                    };
                    console.log("JSESSIONID",jsessionId);
                }).catch(err=>{
                    toast.text("Giriş yapılırken Hata :"+err.message).goAway(4500);
                    this.$store.commit("setLoading",false);
                    console.log(err);
                });
            }
            */

        }
    }
</script>
<style scoped>

</style>
